import angular from 'angular';
import delegatedCardRequestCounterComponent from './delegatedCardRequestCounter.component';

let delegatedCardRequestCounterModule = angular.module('delegatedCardRequestCounter', [])

.component('delegatedCardRequestCounter', delegatedCardRequestCounterComponent)

.name;

export default delegatedCardRequestCounterModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequestCounter/delegatedCardRequestCounter.js